import { DocumentScanner, InsightsOutlined, MenuBookOutlined, Settings, VerifiedUser, List, Menu } from "@mui/icons-material";
import { Box, Divider, Grid, Tab, Tabs } from "@mui/material";
import PageLayout from "../../components/PageLayout";
import { useEffect, useState } from "react";
import AdminInsightsScreen from "./AdminInsightsScreen";
import ProcessManagerScreen from "./ProcessManagerScreen";
import DomainGroupingScreen from "./DomainGroupingScreen";
import UserManagementScreen from "./UserManagementScreen";
import KnowledgeManagerScreen from "./KnowledgeManagerScreen";
import AdminAuditScreen from "./AdminAuditScreen";
import MasterSOPsScreen from "./MasterSOPsScreen";
import { useDispatch, useSelector } from "react-redux";
import { getRequest } from "../../utils/ApiUtil";
import { apiEndpoints, appConfigs } from "../../constants/ApplicationConstants";
import { setPageMessage, setProcessing } from "../../store/ApplicationStore";
import { storeAdminMenu } from "../../store/AdminMenuStore";
import MenuSerializer from "../../serializers/MenuSerializer";
import { useHandleError } from "../others/ErrorScreen";

export default function AdminPanelScreen(){
    const { muiTheme } = useSelector(state => state.user);
    const { adminmenu } = useSelector(state => state.adminmenu);
    const [activeTab, setActiveTab] = useState(0);

    const dispatch= useDispatch();
    const handleError=useHandleError()
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    useEffect(()=>{
        async function fetchAdminMenus(){
            try
            {     
                dispatch(setProcessing(true));
                const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.adminmenu);
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    const fetchedMenus= response.data&&response.data.map((menu)=>{
                        return MenuSerializer(menu)
                    }).filter(obj=>obj)
                    dispatch(storeAdminMenu(fetchedMenus));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))
                }
            }
            catch(err)
            {
                handleError(err)
            }     
        }
        if(!adminmenu){
            fetchAdminMenus();
        }
    },[dispatch, adminmenu,handleError])

    return(
        <PageLayout header footer>
            <Box>
                <Grid container spacing={2}  sx={{ flexGrow: 1 }}>
                    <Grid item xs={12}>
                        <Tabs sx={{
                                minHeight: '30px',
                                height: '30px',
                                '& .MuiTab-root': {
                                minHeight: '30px',
                                height: '30px',
                                padding: '0px 12px',
                                textTransform: 'capitalize',
                                '&:hover': {
                                    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)',
                                },
                                transition: 'text-shadow 0.3s ease',
                                '& .MuiTab-labelIcon': {
                                    minHeight: '30px',
                                },
                                },
                                '& .MuiTabs-indicator': {
                                bottom: '0px',
                                },
                            }} variant='scrollable' scrollButtons='auto' value={activeTab} textColor={muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary'} indicatorColor={muiTheme&&muiTheme.palette.mode==='dark'?"secondary": 'primary'} onChange={handleTabChange}>
                            <Tab icon={<InsightsOutlined />} iconPosition="start" sx={{textTransform: 'capitalize', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}} label="User Adoption Monitor" />
                            <Tab icon={<Menu />} iconPosition="start" sx={{textTransform: 'capitalize', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}} label="Process Manager" />
                            <Tab icon={<List />} iconPosition="start" sx={{textTransform: 'capitalize', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}} label="Domain Group Manager" />
                            <Tab icon={<Settings />} iconPosition="start" sx={{textTransform: 'capitalize', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}} label="User Manager" />
                            <Tab icon={<MenuBookOutlined />} iconPosition="start" sx={{textTransform: 'capitalize', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}} label="Knowledge Manager" />
                            <Tab icon={<VerifiedUser />} iconPosition="start" sx={{textTransform: 'capitalize', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}} label="Admin Activity Logs" />
                          
                           { appConfigs.allowMasterSop && appConfigs.allowMasterSop.toLowerCase()==='y' && <Tab icon={<DocumentScanner />} iconPosition="start" sx={{textTransform: 'capitalize', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}} label="Generated Master SOPs" />}
                        </Tabs>
                    </Grid>
                    <Grid  item xs={12}>
                        <Divider></Divider>
                    </Grid>
                    <Grid item xs={12}>
                        {activeTab === 0 && <AdminInsightsScreen />}
                        {activeTab === 1 && <ProcessManagerScreen />}
                        {activeTab === 2 && <DomainGroupingScreen />}
                        {activeTab === 3 && <UserManagementScreen />}
                        {activeTab === 4 && <KnowledgeManagerScreen />}
                        {activeTab === 5 && <AdminAuditScreen />}
                        {activeTab === 6 && <MasterSOPsScreen />}

                    </Grid>
                </Grid>
            </Box>
        </PageLayout>
    )
}